"use client";

import { PartyPopperIcon } from "lucide-react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Confetti } from "@/components/ui/confetti";

export function PaymentSuccessToast() {
  const searchParams = useSearchParams();
  const _router = useRouter();
  const pathname = usePathname();
  const processedRef = useRef(false);
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    const sessionToken = searchParams.get("customer_session_token");

    // Check if we have the token and haven't processed it yet in this mount
    if (sessionToken && !processedRef.current) {
      processedRef.current = true;

      // Show celebration toast
      toast.success("Thank you for your subscription!", {
        description:
          "Your subscription has been successfully processed. You're amazing!",
        duration: 5000,
        icon: <PartyPopperIcon className="w-4 h-4" />,
      });

      // Trigger confetti
      setShowConfetti(true);
      setTimeout(() => setShowConfetti(false), 5000);

      // Clean up URL without refresh
      const newParams = new URLSearchParams(searchParams.toString());
      newParams.delete("customer_session_token");

      // Construct new URL
      const newUrl = newParams.toString()
        ? `${pathname}?${newParams.toString()}`
        : pathname;

      window.history.replaceState(null, "", newUrl);
    }
  }, [searchParams, pathname]);

  if (!showConfetti) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-50">
      <Confetti />
    </div>
  );
}
